import activityLog from './activityLog';
import auth from './auth';
import booking from './booking';
import user from './user';
import customer from './customer';
import team from './team';
import deal from './deal';
import meeting from './meeting';
import meetingPool from './meetingPool';
import board from './board';
import dashboard from './dashboard';
import reklamation from './reklamation';
import dashboardCards from './dashboard-cards';
import apiKey from './apiKey';
import bookingField from './bookingField';
import bookingSource from './bookingSource';
import consultationSlot from './consultationSlot';
import notification from './notification';
import google from './google';
import callcenter from './callcenter';
import segment from './segment';
import visibility from './visibility';
import wizardSandbox from './wizardSandbox';
import feedback from './feedback';
import search from './search';
import autofix from './autofix';
import mailTemplate from './mailTemplate';
import changelog from './changelog';
import vertriebsservice from './vertriebsservice';
import cockpit from './cockpit';
import prozessdoku from './prozessdoku';
import organigramm from './organigramm';
import applicationType from './applicationType';
import applicationProvider from './applicationProvider';
import applicationVpFields from './applicationVpFields';
import applicationDraft from './applicationDraft';
import applicationTemplate from './applicationTemplate';
import softfairAdmin from './softfairAdmin';
import vermittlerAdmin from './vermittlerAdmin';
import softfair from './softfair';
import dokumentTexte from './dokumentTexte';
import stoerfaelle from './stoerfaelle';

const api = {
  activityLog,
  auth,
  booking,
  user,
  customer,
  team,
  deal,
  meeting,
  meetingPool,
  board,
  dashboard,
  reklamation,
  dashboardCards,
  apiKey,
  bookingField,
  bookingSource,
  consultationSlot,
  notification,
  google,
  callcenter,
  segment,
  visibility,
  wizardSandbox,
  feedback,
  search,
  autofix,
  mailTemplate,
  changelog,
  vertriebsservice,
  cockpit,
  prozessdoku,
  organigramm,
  applicationType,
  applicationProvider,
  applicationVpFields,
  applicationDraft,
  applicationTemplate,
  softfairAdmin,
  vermittlerAdmin,
  softfair,
  dokumentTexte,
  stoerfaelle,
};

export default api;
